import { createContext } from 'react'

const CollapseContext = createContext(null)

export default CollapseContext
